<template>
  <div class="app-version" :title="title">
    клиент {{ clientVersion }} · сервер {{ serverVersion || '…' }}
  </div>
</template>

<script>
import axios from 'axios';
import config from '../config/config.js';

// Версии клиента и сервера внизу страницы.
//
// Номера выдаёт CI на каждый деплой (.gitea/scripts/next-version.sh):
// клиенту — при сборке (VUE_APP_VERSION), серверу — в образ, и он отдаёт
// его в /health. Сервер спрашиваем отдельно: после неудачного деплоя Swarm
// оставляет прежний контейнер, и только так видно, какой на самом деле
// отвечает.
export default {
  name: 'AppVersion',
  props: {},
  data: () => ({
    clientVersion: process.env.VUE_APP_VERSION || 'dev',
    serverVersion: null,
  }),
  computed: {
    title() {
      return 'Версии выдаются на каждый деплой, история — в Gitea → Releases';
    },
  },
  async mounted() {
    try {
      // /health открыт без авторизации — версия видна и на странице входа
      const { data } = await axios.get(`${config.baseURL}/health`);
      this.serverVersion = data?.version || '?';
    } catch {
      this.serverVersion = 'недоступен';
    }
  },
};
</script>

<style scoped>
.app-version {
  position: fixed;
  right: 8px;
  bottom: 4px;
  font-size: 11px;
  color: #666;
  pointer-events: auto;
  z-index: 10;
}
</style>
